import { AppLayout } from '@/components/app-layout';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { OnboardingCheck } from '@/components/onboarding-check.component';
import { RecordsTabsHeader } from '@/components/sidebar/tabs/records-tabs.component';
import { LeadLists } from '@/containers/root/lead-lists.component';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/lists/')({
  component: LeadListsPage,
});

function LeadListsPage() {
  return (
    <>
      <Head heading='Lead Lists' />
      <AuthCheck>
        <OnboardingCheck>
          <AppLayout variant='full-bleed'>
            <RecordsTabsHeader />
            <LeadLists />
          </AppLayout>
        </OnboardingCheck>
      </AuthCheck>
    </>
  );
}
